import React from 'react';

export default class TenantRow extends React.Component {
  constructor(props) {
    super(props);
    this.update = this.update.bind(this)
    this.go = this.go.bind(this)
    this.userList = this.userList.bind(this)
  }

  update(e) {
    const {RowData} = this.props;

    e.stopPropagation()
    this.props.history.push('tenant/update/' + RowData.id)
  }

  userList(e) {
    e.stopPropagation()
    this.props.openModalUserList({
      id : this.props.RowData.id,
      name : this.props.RowData.Name
    })
  }

  go(e) {
    e.stopPropagation()
  }

  render() {
    const {RowData} = this.props;

    return (
      <tr role="button" onClick={(e)=>{e.stopPropagation(); this.props.history.push('tenant/detail/' + RowData.id)}}>
        <td>
          <div>{RowData.Name}</div>
          <div className="small text-muted">
          Phone:&nbsp;{RowData.Phone}
          </div>
        </td>
        <td>
          <div>{RowData.CompanyName}</div>
          <div className="small text-muted">
          Company Phone:&nbsp;{RowData.CompanyPhone}
          </div>
        </td>
        <td>
          {RowData.Email}
        </td>
        <td>
          {RowData.City === null ? "-" : RowData.City.Name}
          <div className="small text-muted">
          Postal code:&nbsp;{RowData.Postal}
          </div>
        </td>
        <td>
          {RowData.Address}
          <div className="small text-muted">
          address 2:&nbsp;{RowData.Address2}
          </div>
        </td>
        <td className="text-center">
          <div className="">
            <button
              className="btn btn-4r btn-sm btn-primary" onClick={this.update}>
              <i className="icon-pencil"></i>
            </button>
            &nbsp;
            <button
              className="btn btn-4r btn-sm btn-success" onClick={this.userList} title="User List">
              <i className="icon-user"></i>
            </button>
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/component/TenantRow.js